import { Space, Dropdown } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDown } from 'react-icons/ai';
import { IssuesContext } from '../context/issues.context';
import IssueTypesList from './IssueTypesList';

const ChangeIssueType = () => {
    const [issueType, setIssueType] = useState<string>();
    const [active, setActive] = useState<boolean>(false);

    const { item } = useContext(IssuesContext);

    const handleActive = () => setActive(!active);

    const onChangeIssueType = (type: string) => {
        setIssueType(type);
    };

    useEffect(() => {
        if (item?.type) {
            setIssueType(item?.type);
        }
    }, [item]);

    return (
        <Dropdown
            trigger={['click']}
            placement="bottomRight"
            visible={active}
            overlay={(
                <IssueTypesList
                    handleActive={handleActive}
                    onChangeIssueType={onChangeIssueType}
                />
            )}
        >
            <Space
                direction="horizontal"
                size={16}
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '0.5px solid #d9d9d9',
                    borderRadius: 4,
                    padding: '2px 6px',
                }}
                onClick={handleActive}
            >
                <span>
                    {
                        issueType || 'Sin tipo'
                    }
                </span>
                <AiOutlineDown
                    size={16}
                    style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                />
            </Space>
        </Dropdown>
    );
};

export default ChangeIssueType;
